"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSegmentationHeaders = void 0;
var _auth = require("@ori/auth");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getAtpClusterId = require("./getAtpClusterId");
var _getCustomerInfo = require("./getCustomerInfo");
/**
 * Utility function to generate request headers for customer segmentation. Returns object with headers.
 *
 * @deprecated Use `getHeaders` or `HeadersProvider` instead.
 */
const getSegmentationHeaders = async ({
  abortController,
  sourceAppName,
  atpClusterId,
  language,
  customerId,
  globalApiUrl,
  staticApiUrl,
  tenant,
  token,
  useProductDataCaching = true,
  useProductsService = true
}) => {
  const headers = (0, _fetching.getHeaders)({
    sourceAppName,
    language,
    customerId,
    tenant,
    token
  });
  headers[_fetching.USE_PRODUCT_DATA_CACHING] = useProductDataCaching;
  headers[_fetching.USE_PRODUCTS_SERVICE] = useProductsService;
  if ((0, _auth.isAuthenticatedCustomer)(customerId)) {
    const globalApiClient = new _globalApiClientReact.ApiClient({
      baseUrl: globalApiUrl,
      language,
      tenant,
      token: (0, _fetching.formatToken)(token)
    });
    const staticApiClient = new _staticApiClientReact.ApiClient({
      baseUrl: staticApiUrl,
      language,
      tenant
    });
    const atpCluster = atpClusterId ?? (await (0, _getAtpClusterId.getAtpClusterId)({
      abortController,
      client: staticApiClient,
      customerId,
      tenant
    }));
    const {
      customerTypeId,
      visitorSegment
    } = await (0, _getCustomerInfo.getCustomerInfo)({
      abortController,
      client: globalApiClient,
      customerId
    });
    if (typeof atpCluster === 'number') {
      headers[_fetching.ATP_CLUSTER_ID] = atpCluster;
    }
    if (typeof customerTypeId === 'number') {
      headers[_fetching.CUSTOMER_TYPE_ID] = customerTypeId;
    }
    if (visitorSegment) {
      headers[_fetching.VISITOR_SEGMENT] = visitorSegment;
    }
  }
  return headers;
};
exports.getSegmentationHeaders = getSegmentationHeaders;
